const ProgressPage: React.FC = () => {
    return (
        <div>ProgressPage</div>
    );
};

export default ProgressPage;